<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">商户订单查询</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
        <el-form-item label="查询时间起：">
            <el-date-picker
              v-model="Time_Start"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              default-time="00:00:00"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="至：">
            <el-date-picker
              v-model="Time_End"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              default-time="23:59:59"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="订单编号">
            <el-input
              v-model="Order_Code"
              placeholder="请输入订单编号" clearable
            ></el-input>
          </el-form-item>
           <el-form-item label="商户单号">
            <el-input
              v-model="Third_OrderNo"
              placeholder="请输入商户单号" clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="交易状态">
              <el-select  filterable placeholder="请选择"  v-model="PayStatus" clearable>
                <el-option
                  v-for="item in PayStatuses"
                  :key="item.PayStatusId"
                  :label="item.PayStatusName"
                  :value="item.PayStatusId">
                </el-option>
              </el-select>
          </el-form-item>
          
          <el-form-item label="商户" prop="BusinessCode">
              <el-select  filterable placeholder="请选择"  v-model="BusinessCode" :disabled="BusinessCodeDisabled" clearable>
                <el-option
                  v-for="item in Businesses"
                  :key="item.BusinessCode"
                  :label="item.BusinessName"
                  :value="item.BusinessCode">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="子商户" prop="ChildBusinessCode">
              <el-select  filterable placeholder="请选择"  v-model="ChildBusinessCode" :disabled="ChildBusinessCodeDisabled" clearable>
                <el-option
                  v-for="item in ChildBusinesses"
                  :key="item.ChildBusinessCode"
                  :label="item.ChildBusinessName"
                  :value="item.ChildBusinessCode">
                </el-option>
              </el-select>
          </el-form-item>
          
          <el-form-item class="right">
            <el-button @click="onSearch">查 询</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>

      <zj-layout-main>
        <!-- <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
          <el-button size="mini" @click="onbatchDel">删 除</el-button>
        </div> -->
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              row-key="TransNo"
              border
              style="width: 100%"
              fixed
            >
             <el-table-column type="expand">
                <template slot-scope="scopeOut">
                  <el-table :data="scopeOut.row.Detials" row-key="ChildTransNo" border  style="width: 100%"  fixed>
                      <el-table-column prop="BusinessName" label="商户"></el-table-column>
                      <el-table-column prop="ChildBusinessName" label="子商户"></el-table-column>
                      <el-table-column prop="ChildTransNo" label="子订单"></el-table-column>
                      <el-table-column prop="SumMoney" label="订单金额"></el-table-column>
                      <el-table-column prop="MainPaySeparate" label="主商户分账金额"></el-table-column>
                      <el-table-column prop="PaySeparate" label="二级商户分账金额"></el-table-column>
                      <el-table-column  prop="PayStatus"  label="状态">
                        <template slot-scope="scope">
                          <div v-if="scope.row.PayStatus==1">支付成功</div>
                          <div v-if="scope.row.PayStatus==2">退款成功</div>
                          <div v-if="scope.row.PayStatus==3">退款失败</div>
                          <div v-if="scope.row.PayStatus==4">待支付</div>
                          <div v-if="scope.row.PayStatus==5">订单取消</div>
                        </template>
                      </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column prop="TransNo" label="订单编号"></el-table-column>
              <el-table-column prop="ThirdOrderNo" label="商户单号"></el-table-column>
              <el-table-column prop="PayMoney" label="订单金额"></el-table-column>
              <el-table-column prop="MainPaySeparate" label="主商户分账金额"></el-table-column>
              <el-table-column prop="PaySeparate" label="二级商户分账金额"></el-table-column>
              <el-table-column prop="PayTime" label="支付时间"></el-table-column>
              <el-table-column prop="PayType" label="支付类型" ></el-table-column>
              <el-table-column  prop="PayState"  label="支付状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.PayState==1">支付成功</div>
                  <div v-if="scope.row.PayState==2">退款成功</div>
                  <div v-if="scope.row.PayState==3">退款失败</div>
                  <div v-if="scope.row.PayState==4">待支付</div>
                  <div v-if="scope.row.PayState==5">订单取消</div>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    @click="queryClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >查看</el-button
                  >
                   <el-button  v-if="scope.row.PayState==1 || scope.row.PayState==3 "
                    @click="returnOrderClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >退款</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
    <ZjDialog
      :title="dilaogconfig.title"
      :dialogFormVisible="dilaogconfig.dialogFormVisible"
      :width="dilaogconfig.width"
      :height="dilaogconfig.height"
      @clickCancel="handleDialogCancel"
    >
      <BusinessOrderInfoPage
        @clickOk="handleDialogOk"
        @clickCancel="handleDialogCancel"
        :Order_No="SelectedOrderNo"
        :IsEdit="isEdit"
      ></BusinessOrderInfoPage>
    </ZjDialog>
  </div>
</template>
<script>

import utils from "../../../../../../utils";
import WebApis from "../../../apis";
import { showLoading, hideLoading } from "../../../../../../loading";
import BusinessOrderInfoPage from "./BusinessOrderInfo.vue";

export default {
  name: "BusinessOrderQueryPage",
  controller: "UI",
  action: "BusinessQueryOrder",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      Orgs: null,
      Order_Code: null,
      Third_OrderNo:null,
      SelectedOrderNo: null,
      tableHeight: window.innerHeight - 440,
      dilaogconfig: {
        title: "查看订单信息",
        dialogFormVisible: false,
        width: "900px",
      },
      multipleSelection: [],
      isEdit: false,
      Businesses:[],
      BusinessCode:"",
      BusinessCodeDisabled:false,
      ChildBusinesses:[],
      ChildBusinessCode:"",
      ChildBusinessCodeDisabled:false,
      Time_Start: this.get_Day(-7)+" 00:00:00",
      Time_End: this.get_Day(0)+" 23:59:59",
      PayStatus:0,
      PayStatuses:[
        {
          PayStatusId:0,
          PayStatusName:"全部"
       },
       {
          PayStatusId:1,
          PayStatusName:"支付成功"
       },
        {
          PayStatusId:2,
          PayStatusName:"退款成功"
       },
        {
          PayStatusId:3,
          PayStatusName:"退款失败"
       },
        {
          PayStatusId:4,
          PayStatusName:"待支付"
       },
        {
          PayStatusId:5,
          PayStatusName:"订单取消"
       }
      ]
    };
  },
  components: {
    BusinessOrderInfoPage,
  },
  props: {
    width: {
      type: String,
      default: "200px",
    },
  },
  created: function () {
    this.init();
  },
  mounted: function () {
    const that = this;
    window.onresize = () => {
      return (() => {
        that.tableHeight = window.innerHeight - 440;
      })();
    };
    //this.GetBusinessOrder();
    this.logInfo.ActionName = "商户订单信息查询";
    this.logInfo.LogMessage = "商户订单信息查询";
    this.logInfo.ModuleName = "统一管理";
    this.logInfo.PageName = "商户订单信息查询";
    this.addOperationLog();
  },
  computed: {},
  watch:{
    BusinessCode(val){
      this.ChildBusinessCode="";
      this.GetChildBusinesses(val);
    }
  },
  methods: {
    init() {
      return utils.waitAll([
                            () => this.GetBusiness()
                          ]).then(()=>{

                              this.GetBusinessOrder();
                          });
    },
    GetBusiness(){
        return new WebApis.BusinessApi()
        .FindAll()
        .then((r) => {
          console.log(r);
          r = r.data.Data;
          this.Businesses = r;
          this.InitChildBusiness();
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取商户数据异常！" + e.RspMsg
              : "获取商户数据异常！",
            type: "error",
          });
        });
    },
    InitChildBusiness()
    {
      let user = this.user;

      if(user.LoginName!="admin")
      {
          var SelectedBusiness= this.GetBusinessByUser(user);

          if(SelectedBusiness)
          {
            this.BusinessCode = SelectedBusiness.BusinessCode;
            if(SelectedBusiness.IsMain=="1")
            {
               this.BusinessCode="";
               this.BusinessCodeDisabled=false;
            }
          }

          if(!this.BusinessCode)
          {
              this.GetChildBusinessByChildBusinessCode(user.LoginName);
          }
          else
          {
              this.GetChildBusinesses(this.BusinessCode);
              this.BusinessCodeDisabled=true;
          }
      }
      else
      {
        this.BusinessCode="";
        this.BusinessCodeDisabled=false;
      }
    },
    GetBusinessByUser(user)
    {
       var result="";
        this.Businesses.forEach(function(item){
            if(item.BusinessCode==user.LoginName)
            {
              result= item;
              return;
            }
        });
        return result;
    },
    GetChildBusinesses(BusinessCode) {

      let ChildBusinessSearch = {
        BusinessCode:BusinessCode
      };

      return new WebApis.ChildBusinessApi()
        .FindByConditions(ChildBusinessSearch)
        .then((r) => {
          this.ChildBusinesses = r.data.Data;
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取子商户数据异常！" + e.RspMsg
              : "获取子商户数据异常！",
            type: "error",
          });
        });
    },
    GetChildBusinessByChildBusinessCode(ChildBusinessCode)
    {
       let ChildBusinessSearch = {
        ChildBusinessCode:ChildBusinessCode
      };

      new WebApis.ChildBusinessApi()
        .GetItemByBusinessCodeAndChildBusinessCode(ChildBusinessSearch)
        .then((r) => {
          var result = r.data.Data;
          if(result)
          {
            this.BusinessCode = result.BusinessCode;
            this.BusinessCodeDisabled=true;
            utils.waitAll([
                      () => this.GetChildBusinesses(this.BusinessCode)
                    ]).then(()=>{
                        this.ChildBusinessCode = result.ChildBusinessCode;
                        this.ChildBusinessCodeDisabled=true;
                    });
          }
          
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取子商户数据异常！" + e.RspMsg
              : "获取子商户数据异常！",
            type: "error",
          });
        });
    },
    GetBusinessOrder() {
      showLoading(".zj-table-container");

      let BusinessOrderSearch = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        PayState:this.PayStatus==0?null:this.PayStatus,
        TransNo: this.Order_Code == "" ? null : this.Order_Code,
        ThirdOrderNo:this.Third_OrderNo == "" ? null : this.Third_OrderNo,
        BusinessCode:this.BusinessCode==""?null:this.BusinessCode,
        ChildBusinessCode:this.ChildBusinessCode==""?null:this.ChildBusinessCode,
        BeginDate:new Date(this.Time_Start),
        EndDate:new Date(this.Time_End),
        TotalCount: 0
      };

      console.log(BusinessOrderSearch);
      return new WebApis.BusinessPayOrderApi()
        .GetDataPageContentByConditions(BusinessOrderSearch)
        .then((r) => {
          console.log(r);
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          hideLoading();
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取商户订单数据异常！" + e.RspMsg
              : "获取商户订单数据异常！",
            type: "error",
          });
          hideLoading();
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage=1;
      this.GetBusinessOrder();
    },
    clearsearch() {
      this.Order_Code = "";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetBusinessOrder();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.GetBusinessOrder();
    },
    formatDate(dateTime)
    {
      const date = new Date(dateTime);
      return (
        date.getFullYear() +
        "-" +
        (date.getMonth()+1) +
        "-" +
        date.getDate()
      );
    },
    formatTime(row, column) {
      const date = new Date(row[column.property]);
      return (
        date.getFullYear() +
        "年" +
        date.getMonth() +
        "月" +
        date.getDate() +
        "日"
      );
    },
    queryClick(index, row) {
      this.SelectedOrderNo = row.TransNo;
      this.isEdit = false;
      this.dilaogconfig.title = "查看商户订单信息";
      this.dilaogconfig.dialogFormVisible = true;
    },
    handleDialogOk() {
      this.dilaogconfig.dialogFormVisible = false;
      this.GetBusinessOrder();
    },
    handleDialogCancel() {
      this.dilaogconfig.dialogFormVisible = false;
    },
    returnOrderClick(index, row)
    {
        const that = this;

     

      this.$confirm("确定退款?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
      
          let ReturnArgs={
              OrderNo:row.TransNo,
              ReturnAmount:row.PayMoney,
              ReturnDetials:null
            }


          new WebApis.BusinessPayOrderApi()
              .ReturnOrder(ReturnArgs)
              .then((r)=>{
                console.log("退款",r);
                    if (r.RspCode == "1") {
                      if(r.data.Data.Status==0)
                      {
                        that.$message({ type: "success", message: "退款成功!" });
                        
                        this.GetBusinessOrder();
                      }
                      else
                      {
                        this.$message({
                          showClose: true,
                          message: r.data.Data.Response.Msg,
                          type: "error",
                        });
                        
                        return false;
                      }
                    }
                    else{
                      that.$message({ type: "error", message: "退款失败!"+r.data.Data.Response.Msg });
                    }
              }).catch((e)=>{
                console.log("退款失败",e);
                that.$message({
                        showClose: true,
                        message: e ? e.RspMsg+" "+e.data.Data.Response.Msg : "退款失败!",
                        type: "error",
                      });
              });
        });
    },
    get_Day(day) {
      let today = new Date();
      let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds);
      let tYear = today.getFullYear();
      let tMonth = today.getMonth();
      let tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      //let timevalue= new Date(tYear + "-" + tMonth + "-" + tDate);
      let timevalue = tYear + "-" + tMonth + "-" + tDate;
      return timevalue;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    }
  },
};
</script>